var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLvl4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 211.74 277.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill:#fff;}.cls-3{font-family:Mont-HeavyDEMO, Mont;font-size:71.68px;letter-spacing:.04em;}.cls-4{fill:url(#linear-gradient-6);}.cls-5{fill:url(#linear-gradient-11);}.cls-6{fill:url(#linear-gradient-10);}.cls-7{fill:#343652;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-7);}.cls-10{fill:url(#linear-gradient-9);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient);}.cls-13{fill:url(#linear-gradient-4);}.cls-14{fill:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-12);}.cls-16{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 95.06,
    y1: 65.61,
    x2: 95.06,
    y2: 229.29,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 140.77,
    y1: 65.61,
    x2: 140.77,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 140.77,
    y1: 65.61,
    x2: 140.77,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 140.77,
    y1: 65.61,
    x2: 140.77,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 140.76,
    y1: 65.61,
    x2: 140.76,
    y2: 229.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 135.85,
    y1: 283.01,
    x2: 92.82,
    y2: 122.52,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f05a26",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f05a26"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -6.97,
    y1: 153.19,
    x2: 52.01,
    y2: 163.34,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#41bb95",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41bb95"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 121.22,
    y1: 56.13,
    x2: 101.4,
    y2: 162.49,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9cf2f",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f9cf2f"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 105.87,
    cy: 171.19,
    r: 105.87
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(80.18 187.55) scale(1.09 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("circle", {
    className: "cls-7",
    cx: 105.87,
    cy: 171.19,
    r: 90.97
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M132.08,195.42h-8.09v14.77h-22.99v-14.77H58.04v-4.02l28.66-63.43h23.77l-22.16,49.03h14.31l5.25-18.11h16.12v18.11h8.09v18.42Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.47,209.16v-2.61h8.59v2.61h-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M145.06,194.94l-4.95,.73,4.96,2.48v.76l-4.96,2.48,4.95,.72v2.61l-8.59-1.42v-2.58l4.67-2.2-4.67-2.22v-2.58l8.59-1.4v2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M145.06,181.28l-4.95,.73,4.96,2.48v.76l-4.96,2.48,4.95,.72v2.61l-8.59-1.42v-2.58l4.67-2.2-4.67-2.22v-2.58l8.59-1.4v2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M143.01,170.78h2.05v6.1h-8.59v-5.99h2.05v3.42h1.26v-3.07h1.94v3.07h1.28v-3.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.43,165.26v.94h2.63v2.58h-8.59v-4.06c0-2.02,1.24-3.48,3.04-3.48,1.05,0,1.92,.56,2.43,1.49l3.12-1.86v2.88l-2.63,1.52Zm-1.99,.94v-1.18c0-.72-.4-1.14-.94-1.14s-.93,.42-.93,1.14v1.18h1.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M142.28,159.68v-2.66c.61,0,.91-.52,.91-1.1,0-.54-.26-1.06-.73-1.06-.54,0-.7,.73-.89,1.62-.31,1.35-.69,3.08-2.64,3.08-1.69,0-2.66-1.36-2.66-3.56s1.06-3.53,2.81-3.53v2.59c-.54,0-.8,.44-.8,.98,0,.46,.18,.9,.58,.9,.49,0,.65-.71,.85-1.59,.33-1.38,.75-3.18,2.71-3.18s2.85,1.57,2.85,3.74c0,2.29-1.11,3.77-2.98,3.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M136.47,150.28v-2.61h8.59v2.61h-8.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M136.47,136.59l8.59,3.58v2.4l-8.59,3.66v-2.94l5.34-1.91-5.34-1.86v-2.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M143.01,129.01h2.05v6.1h-8.59v-5.99h2.05v3.42h1.26v-3.07h1.94v3.07h1.28v-3.53Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M206.56,138.48l-41.5,13.49c1.97,6.06,3.04,12.52,3.04,19.23s-1.08,13.17-3.04,19.23c-2.04,6.28-5.05,12.12-8.85,17.34-3.84,5.28-8.49,9.92-13.77,13.77-5.23,3.8-11.06,6.81-17.34,8.85-6.06,1.97-12.52,3.04-19.23,3.04s-13.17-1.08-19.23-3.04c-6.28-2.04-12.12-5.05-17.34-8.85-5.28-3.84-9.92-8.49-13.77-13.77-3.8-5.23-6.81-11.06-8.85-17.34-1.97-6.06-3.04-12.52-3.04-19.23H0C0,182.62,1.83,193.6,5.18,203.91c3.47,10.68,8.59,20.61,15.06,29.5,6.53,8.98,14.44,16.88,23.42,23.42,8.89,6.47,18.82,11.59,29.5,15.06,10.31,3.35,21.3,5.18,32.72,5.18s22.41-1.83,32.72-5.18c10.68-3.47,20.61-8.59,29.5-15.06,8.98-6.53,16.88-14.44,23.42-23.42,6.47-8.89,11.59-18.82,15.06-29.5,3.35-10.31,5.18-21.3,5.18-32.72s-1.83-22.41-5.18-32.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M5.18,138.48C1.83,148.78,0,159.77,0,171.19H43.64c0-6.71,1.08-13.17,3.04-19.23l-41.5-13.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M191.51,108.97c-6.53-8.98-14.44-16.88-23.42-23.42-8.89-6.47-18.82-11.59-29.5-15.06-10.31-3.35-21.3-5.18-32.72-5.18s-22.41,1.83-32.72,5.18c-10.68,3.47-20.61,8.59-29.5,15.06-8.98,6.53-16.88,14.44-23.42,23.42-6.47,8.89-11.59,18.82-15.06,29.5l41.5,13.49c2.04-6.28,5.05-12.12,8.85-17.34,3.84-5.28,8.49-9.92,13.77-13.77,5.23-3.8,11.06-6.81,17.34-8.85,6.06-1.97,12.52-3.04,19.23-3.04s13.17,1.08,19.23,3.04c6.28,2.04,12.12,5.05,17.34,8.85,5.28,3.84,9.92,8.49,13.77,13.77,3.8,5.23,6.81,11.06,8.85,17.34l41.5-13.49c-3.47-10.68-8.59-20.61-15.06-29.5Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M32.59,36.93h14.51v8.55H21.51V0h11.08V36.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M62.2,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M127.58,0l-16.13,45.49h-13.87L81.44,0h11.79l11.27,34.34L115.85,0h11.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M141.96,8.88v9.2h14.84v8.55h-14.84v9.98h16.78v8.88h-27.86V0h27.86V8.88h-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M175.72,36.93h14.51v8.55h-25.59V0h11.08V36.93Z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLvl4);
export default __webpack_public_path__ + "static/media/lvl4.e5d6e08b096fc862dc3f7a35635c8aeb.svg";
export { ForwardRef as ReactComponent };